import { render, staticRenderFns } from "./WsDevArrayTable.vue?vue&type=template&id=49cb7fbc&"
import script from "./WsDevArrayTable.vue?vue&type=script&lang=js&"
export * from "./WsDevArrayTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports